import validate from "/usr/src/app/content/n3-spas-49381eb1-b85a-467d-a88d-bcd185c73278/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-49381eb1-b85a-467d-a88d-bcd185c73278/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}